module.exports = __webpack_public_path__ + "img/lock-status.042efb20.svg";